import React from 'react'
import PageLayout from '../PageLayout'
import ConfiguredPartsTable from './ConfiguredPartsTable'

// const useStyles = makeStyles(theme => ({
//     content: {
//        //
//     },
// }))


export default function AppConfiguredPartsPage() {
    // const classes = useStyles()

    // console.log('AppConfiguredPartsPage render')

    return (
        <PageLayout>
            <ConfiguredPartsTable />
        </PageLayout>
    )
}

